import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const FacebookScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.3333 13.25H16.3889L17 9.5H13.3333V7.625C13.3333 6.375 13.7245 5.75 15.1667 5.75H17V2.125C17 2.125 16.2044 2 14.1571 2C12.1111 2 9.66667 3.9575 9.66667 7V9.5H6V13.25H9.66667V22H13.3333V13.25Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Facebook'
);
export default FacebookScaleMediumAppearanceDefault;
